$(document).ready(function() {

    let header = $("header");
    let headerOffset = header.offset().top;

    $(window).on("scroll", function() {
        if ($(this).scrollTop() > 0) {
            header.addClass("fixed");
        } else {
            header.removeClass("fixed");
        }
    });

    const btn = $('[data-type="bar"], [data-type="close"]');
    const menu = $('.header__item:nth-child(2)');

    btn.on('click', function(e) {
        e.preventDefault();

        if (menu.is(':visible')) {
            menu.slideUp(300);
            btn.attr('data-type', 'bar');
        }
        else {
            menu.slideDown(300);
            btn.attr('data-type', 'close');
        }
    });


    function initCatalogAccordion() {
        if ($(window).width() <= 1000) {

            $('.catalog__box__content').hide();
            $('.catalog__box > p').off('click').on('click', function () {
                let parent = $(this).closest('.catalog__box');
                let content = parent.find('.catalog__box__content');

                $(this).toggleClass('active');

                content.slideToggle(250);
            });

        } else {
            $('.catalog__box__content').show();
            $('.catalog__box > p').removeClass('active');
            $('.catalog__box > p').off('click');
        }
    }

    initCatalogAccordion();

    $(window).on('resize', function () {
        initCatalogAccordion();
    });

    $('.faq__row .faq__item > p').hide();

    $('.faq__row').on('click', '.faq__item > b', function(e){
        var $b = $(this);
        var $p = $b.next('p');

        $p.stop(true, true).slideToggle(200);
        $b.toggleClass('active');
        $b.attr('aria-expanded', $b.hasClass('active').toString());
    });

    $('.faq__row').on('keydown', '.faq__item > b', function(e){
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault();
            $(this).trigger('click');
        }
    });
});